import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { getAreas, getShipRegion } from '@/services/api';
import { genAreasMap } from '@/utils';
import { SHIP_REGION } from '@/utils/constant';

type AreasInfo = {
  areas: API.Region[];
  areasMap: Record<string, string>;
  countryInfo: API.Region;
};

export const areasInfoAtom = atom<AreasInfo>({
  areas: [],
  areasMap: {},
  countryInfo: {},
});

export const queryAreasInfoAtom = atom(
  (get) => get(areasInfoAtom),
  async (_, set) => {
    try {
      const res = await getAreas();
      const countryInfo = res.data?.find((v) => v.adCode === '100000') || {};
      const areas = countryInfo?.children || res.data || [];
      const areasMap = genAreasMap(areas);
      set(areasInfoAtom, {
        areas,
        areasMap,
        countryInfo: areas[0],
      });
    } catch (error) {}
  },
);

export const shipRegionAtom = atomWithStorage<API.SaleRegion>(SHIP_REGION, {
  countryAdCode: '100000',
  provinceAdCode: '310000',
  cityAdCode: '310100',
});

/** 客户访问商城初始化话的配送至逻辑
 * 优先级1：如果存在最近的订单记录，则以最近订单收货地址确定配送至地址
 * 优先级2：如果存在客户to自营（溢荣美乐）的销区，取客户to自营（溢荣美乐）第一个销区地址
 * 优先级3：如果设备本地存在配送至地址，以设备本地的配送至为准
 * 优先级4：默认为上海
 **/
export const initShipRegionAtom = atom(null, async (get, set) => {
  try {
    const shipRegion = get(shipRegionAtom);
    const res = await getShipRegion();
    set(shipRegionAtom, res.data || shipRegion);
  } catch (error) {}
});
